import React, { Component } from 'react'
import { connect } from 'react-redux'

import Part from './../Part'
import Photo from '../Photo'
import Comment from '../Comment'

// Elements
import Button from '../../../elements/button'
import PanelHeader from '../../../elements/panelHeader'
import Radio from '../../../elements/radio'
import Text from '../../../elements/text'
import Check from '../../../elements/check'
// import PanelHeader from '../../../elements/panelHeader'

import { reverseFormatCurrency2, formatCurrency2 } from '../../../../utils/currency'
import { getShop } from '../../../../actions/shops'

import { translation } from '../../../../utils/helpers'

import './deviation.scss'
import Divider from '../../../elements/divider'

class Deviation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: null,
      order: null,
      deviation: null
    }
    this.deviationInitialized = false
  }

  componentDidMount () {
    this.props.onRef(this)
    this.props.getShop(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        transferDeviation: res.data.AddExternalDeviations
      })
    })
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    if (typeof next.orderPrice !== 'object') return

    let deviation = {
      MoveBackStepId: next.router.location.state ? next.router.location.state.stepId : next.order.StepId,
      ShowCostCustomer: false,
      TransferCostToInvoice: false,
      DeviationFiles: []
    }

    if (next.orderPrice.Deviations.length > 0) deviation = next.orderPrice.Deviations[0]
    else next.orderPrice.Deviations[0] = deviation

    this.setState({
      price: next.orderPrice,
      deviation: deviation,
      order: next.order
    }, () => {
      if (!this.deviationInitialized) {
        this.deviationInitialized = true
        this.savePrice()
      }
    })
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    return translation(333)
  }

  onDelete (part, reason) {
    if (part && reason) {
      if (reason.DeviationReasonId !== undefined) {
        part.DeviationReasons.map(x => {
          if (x.DeviationReasonId === reason.DeviationReasonId) x.IsDeleted = true
          return x
        })
      } else if (reason.CustomDeviationReasonId !== undefined) {
        part.CustomDeviationReasons.map(x => {
          if (x.CustomDeviationReasonId === reason.CustomDeviationReasonId) x.IsDeleted = true
        })
      }

      // this.state.price.Parts.map(x => {
      //   if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part
      //   return x
      // })

      this.savePrice()
    }
  }

  savePrice () {
    let price = this.state.price
    price.Deviations[0] = this.state.deviation
    return this.props.saveOrderPrice(price)
  }

  renderStepSection () {
    const getNameTranslation = (id) => {
      switch (id) {
        case 1:
          return 164
        case 2:
          return 96
        case 3:
          return 160
        case 4:
          return 158
        case 5:
          return 161
        case 6:
          return 162
        case 7:
          return 163
        case 8:
          return 23
        default:
          return ''
      }
    }
    const onChange = (e) => {
      this.setState({
        deviation: {
          ...this.state.deviation,
          MoveBackStepId: parseInt(e.target.value)
        },
        hasChanged: true
      }, () => {
        setTimeout(() => {
          this.savePrice()
        }, 50)
      })
    }
    let steps = Array.apply(null, { length: this.state.order.StepId }).map(Number.call, Number)

    // Return
    return (
      <div className='deviationMoveBackward'>
        <PanelHeader text={translation('13481')} />
        {steps.map((val, key) => {
          let id = val + 1
          let name = getNameTranslation(id)
          let disabled = false
          let stepId = this.state.deviation.MoveBackStepId

          if (this.state.order.IsArchived || this.state.order.StepId === 8) {
            disabled = true
          }
          return (
            <Radio key={key} labelText={translation(name)} id={'step-' + id} name='Step' value={id} checked={stepId === id} onChange={onChange} disabled={disabled} />
          )
        })}
      </div>
    )
  }

  renderCostSection () {
    const onBlur = (e) => {
      this.setState({
        deviation: {
          ...this.state.deviation,
          Cost: parseFloat(reverseFormatCurrency2(e.target.value))
        }
      }, () => {
        setTimeout(() => {
          this.savePrice()
        }, 50)
      })
    }
    const onInputChange = (e) => {
      this.setState({
        deviation: {
          ...this.state.deviation,
          Cost: e.target.value
        }
      })
    }
    const onCheckChange = (e) => {
      this.setState({
        deviation: {
          ...this.state.deviation,
          [e.target.name]: e.target.checked
        }
      }, () => {
        setTimeout(() => {
          this.savePrice()
        }, 50)
      })
    }

    let showCostCustomer = this.state.deviation.ShowCostCustomer === true
    let transferCostToInvoice = this.state.deviation.TransferCostToInvoice === true
    let isInternal = this.state.price.IsInternalDeviation === true
    return (
      <div className='deviationCost'>
        <PanelHeader text={translation('337')} />
        <Text value={formatCurrency2(this.state.deviation.Cost)} onBlur={onBlur} onChange={onInputChange} />
        {!isInternal && (
          <Check labelText={translation('14935')} id='Cost_ShowToCustomer' name='ShowCostCustomer' onChange={onCheckChange} checked={showCostCustomer} disabled={!this.props.editable} />
         )}
        {!isInternal && (
          <Check labelText={translation('14936')} id='Cost_TransferToInvoice' name='TransferCostToInvoice' onChange={onCheckChange} checked={transferCostToInvoice} disabled={!this.state.transferDeviation} />
          )}
      </div>
    )
  }

  renderReason () {
    return (
      <div>
        <PanelHeader text={translation('333')} />
        {this.state.price.Parts.map((val) => {
          return <Part
            key={'part_' + val.Part.PartItemId + '_' + val.Part.TaskSide}
            part={val}
            onDelete={this.props.editable === true && this.onDelete.bind(this, val)}
            editable={this.props.editable}
            />
        })}
      </div>
    )
  }

  render () {
    if (!this.state.price || !this.state.order || !this.state.deviation) return null

    const goBack = () => {
      this.setState({
        deviation: {
          ...this.state.deviation,
          Active: true,
          SendToApproval: true
        }
      }, () => {
        this.savePrice().then(() => {
          this.props.goBack()
        })
      })
    }

    const changeSource = this.state.price.IsInternalDeviation ? 9 : this.state.price.IsExternalDeviation ? 10 : null
    const comment = this.state.deviation.Comment

    let css = 'price__view'
    if (this.props.editable) {
      css += ' editable'
    }

    // If there is no reasons then user cant save - we disable the button
    let hasReasons = this.state.price.Parts[0] ? this.state.price.Parts[0].DeviationReasons.length > 0 || this.state.price.Parts[0].CustomDeviationReasons.length > 0 : false
    return (
      <div className={css}>
        {this.props.viewMode === 'mobile' && this.props.renderInside()}
        <PanelHeader text={translation('889')} />
        {this.renderReason()}
        {this.renderStepSection()}
        {this.renderCostSection()}
        <Photo
          saveOrder={this.props.saveOrder}
          saveOrderPrice={this.props.saveOrderPrice}
          orderPrice={this.state.price}
          order={this.state.order}
          loadOrder={this.props.loadOrder} />
        <Comment
          comment={comment}
          changeSource={changeSource}
          deviationId={this.state.deviation.DeviationId}
          order={this.state.order}
          transferDeviation={this.state.transferDeviation} />
        <Divider noLine />
        {this.props.editable && <Button disabled={hasReasons === false} onClick={goBack} labelText={translation('956')} />}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getShop
})(Deviation)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Deviation/index.js